import * as React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './NumberInputModal.module.css';
import { GuestType } from 'models/product';
import { useField } from 'react-final-form';
import { FormControl, FormLabel, Input } from '@mui/material';

interface Props {
  guestType: GuestType;
  open: boolean;
  onClose: () => void;
}

export const NumberInputModal = ({ guestType, open, onClose }: Props) => {
  const { t } = useTranslation();
  const modalRef = React.useRef<HTMLDivElement>(null);

  const { input } = useField(`guestCount.${guestType.key}`);

  const [inputNumber, setInputNumber] = React.useState<string>(input?.value ?? '0');

  const closeHandler = () => {
    onClose();
  };

  React.useEffect(() => {
    const onWindowClick = (event: MouseEvent | TouchEvent) => {
      if (modalRef && !modalRef.current?.contains(event.target as Node)) {
        closeHandler();
      }
    };

    window.addEventListener('mousedown', onWindowClick);

    return () => {
      window.removeEventListener('mousedown', onWindowClick);
    };
  }, []);

  return (
    <>
      <div className={clsx(styles['modal'], open ? styles['is-active'] : null)}>
        <div className={styles['modal__inner']}>
          <div className={styles['modal__content']}>
            <div ref={modalRef} className={styles['c-review__modal__content']}>
              <div className={styles['modal__content__memo']}>{t('Input the number of guest')}</div>
              <div className={styles['modal__content__txt']}>
                {t('Please input the number of guest.')}
              </div>

              <FormControl
                variant="standard"
                margin="normal"
                sx={{
                  width: '100%',
                  marginBottom: '20px',
                }}
              >
                <FormLabel htmlFor="bootstrap-input" sx={{ fontWeight: 700 }}>
                  {guestType.title}
                </FormLabel>
                <Input
                  autoFocus
                  value={inputNumber}
                  onChange={(props) => {
                    if (Number(props.target.value) < 0) {
                      return;
                    }
                    setInputNumber(props.target.value);
                  }}
                  type="number"
                />
              </FormControl>

              <>
                <div className={styles['modal__content__btns']}>
                  <button
                    type="button"
                    className={clsx(styles['btn'], styles['btn--submit'])}
                    onClick={() => {
                      input.onChange(inputNumber || '0');
                      closeHandler();
                    }}
                  >
                    {t('Confirm')}
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
        <div className={styles['modal__overlay']}></div>
      </div>
    </>
  );
};
